import { render } from "./PixelCanvas.vue?vue&type=template&id=6107fb3d&scoped=true"
import script from "./PixelCanvas.vue?vue&type=script&lang=js"
export * from "./PixelCanvas.vue?vue&type=script&lang=js"

import "./PixelCanvas.vue?vue&type=style&index=0&id=6107fb3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6107fb3d"]])

export default __exports__